import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import leaderboardReducer from './slices/leaderboardSlice';
import verificationReducer from './slices/verificationSlice';
import uiReducer from './slices/uiSlice';

// Middleware to sync notifications with react-hot-toast
const notificationMiddleware = () => (next) => (action) => {
  const result = next(action);

  // Handle notifications
  if (action.type === 'ui/addNotification') {
    // You can import toast here if needed
    // import toast from 'react-hot-toast';
    // toast[action.payload.type](action.payload.message);
  }

  return result;
};

const store = configureStore({
  reducer: {
    auth: authReducer,
    leaderboard: leaderboardReducer,
    verification: verificationReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['ui/addNotification'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.timestamp'],
        // Ignore these paths in the state
        ignoredPaths: ['ui.notifications'],
      },
    }).concat(notificationMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;

// Export types for TypeScript support (optional)
export const RootState = store.getState;
export const AppDispatch = store.dispatch;
